module.exports = __webpack_public_path__ + "static/media/418.0cd9523d.webp";